import { useAuth } from "@/contexts/AuthContext"
import { Icon, Text } from "../atoms"

// Interface para as novas props baseadas nos dados da V2
interface MentorQuantities {
  qtdMentor: number | string
  qtdEspecialista: number | string
}

interface CompaniesDashProps {
  onMainMentorCounterCLick: () => void
  onSpecialistMentorCounterClick: () => void
  showOnlyapenasPrincipal: boolean
  showOnlyMySpecialistCompanies: boolean
  mentorData: MentorQuantities | null // Recebido via Props do pai
}

export const CompaniesDash = ({
  onMainMentorCounterCLick,
  onSpecialistMentorCounterClick,
  showOnlyapenasPrincipal,
  showOnlyMySpecialistCompanies,
  mentorData,
}: CompaniesDashProps) => {
  // Se os dados ainda não chegaram do pai, não renderizamos nada ou um esqueleto
  if (!mentorData) return null
  const { user } = useAuth()

  return (
    <section className="flex justify-center gap-4 px-10">
      {/* Mentor Principal */}
      <div
        onClick={onMainMentorCounterCLick}
        className={`group relative flex max-w-[1200px] cursor-pointer items-center justify-center px-12 py-4 transition-all ${
          showOnlyMySpecialistCompanies ? "opacity-50" : ""
        }`}
      >
        <div className="z-10 flex flex-1 items-center justify-between gap-20">
          <div className="flex items-center gap-4">
            <div className="flex size-[50px] min-w-[50px] items-center justify-center rounded-[8px] border border-primary bg-primary/20">
              <Icon
                name="review"
                color="primary"
              />
            </div>
            <div className={`max-w-[300px] ${showOnlyapenasPrincipal ? "text-primary" : ""}`}>
              <Text variant="h6">
                {user.admin ? "Mentores principais" : "Empresas como mentor principal"}
              </Text>
            </div>
          </div>
          <Text
            variant="h4"
            className="text-primary"
          >
            {mentorData.qtdMentor}
          </Text>
        </div>

        <div
          className={`absolute h-full w-full skew-x-[-45deg] cursor-pointer rounded-bl-[8px] rounded-br-[12px] rounded-tl-[12px] rounded-tr-[8px] border border-primary bg-dark-500 transition-all transition-colors group-hover:bg-primary/20 ${
            showOnlyapenasPrincipal ? "bg-primary/10" : ""
          }`}
        />
      </div>

      {/* Mentor Especialista */}
      <div
        onClick={onSpecialistMentorCounterClick}
        className={`group relative flex max-w-[1200px] cursor-pointer items-center justify-center px-12 py-4 ${
          showOnlyapenasPrincipal ? "opacity-50" : ""
        }`}
      >
        <div className="z-10 flex flex-1 items-center justify-between gap-20">
          <div className="flex items-center gap-4">
            <div className="flex size-[50px] min-w-[50px] items-center justify-center rounded-[8px] border border-info bg-info-dark">
              <Icon
                name="user-link"
                color="info"
              />
            </div>
            <div className={`max-w-[300px] ${showOnlyMySpecialistCompanies ? "text-info" : ""}`}>
              <Text variant="h6">
                {user.admin ? "Mentores especialistas" : "Empresas como mentor especialista"}
              </Text>
            </div>
          </div>
          <Text
            variant="h4"
            className="text-info"
          >
            {mentorData.qtdEspecialista}
          </Text>
        </div>

        <div
          className={`absolute h-full w-full skew-x-[-45deg] rounded-bl-[8px] rounded-br-[12px] rounded-tl-[12px] rounded-tr-[8px] border border-info bg-dark-500 transition-colors group-hover:bg-info/20 ${
            showOnlyMySpecialistCompanies ? "bg-info/10" : ""
          } `}
        />
      </div>
    </section>
  )
}
